// src/components/ModeloDescripcion/ModeloDescripcion.jsx
import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import styles from './ModeloDescripcion.module.scss';

const containerVariants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.15 }
  }
};

const titleVariants = {
  hidden: { x: -50, opacity: 0 },
  visible: { x: 0, opacity: 1, transition: { duration: 0.5 } }
};

const cardVariants = {
  hidden: { x: 50, opacity: 0 },
  visible: { x: 0, opacity: 1, transition: { duration: 0.5 } }
};

const textVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.5 } }
};

const ModeloDescripcion = ({ modelo }) => {
  const ref = useRef(null);
  // dispara cuando al menos el 20% del contenedor está visible, sólo una vez
  const isInView = useInView(ref, { amount: 0.2, once: true });

  return (
    <motion.div
      ref={ref}
      className={styles.descripcionContainer}
      variants={containerVariants}
      initial="hidden"
      animate={isInView ? 'visible' : 'hidden'}
    >
      <motion.h3
        className={styles.descripcionTitle}
        variants={titleVariants}
      >
        Descripción
      </motion.h3>
      <motion.div
        className={styles.descripcionCard}
        variants={cardVariants}
      >
        <motion.p
          className={styles.descripcionText}
          variants={textVariants}
        >
          {modelo.descripcion}
        </motion.p>
      </motion.div>
    </motion.div>
  );
};

export default ModeloDescripcion;
